import React from 'react'
import ReportView from '../components/ReportView'

const ReportTab = ({tab, data}) => <ReportView tab={tab} data={data}/>

export default ReportTab
